<template>
  <div v-if="taskLoading" class="task-done">
    <span>Carregando...</span>
    <br>
    <img class="loader" :src="`${basePath}images/loader.gif`" width="80px"/>
  </div>
  <div v-else-if="items.length > 0" class="tasks">
    <!--<div>-->
    <!--<v-card-text>-->
    <!--<v-progress-linear-->
    <!--indeterminate-->
    <!--color="teal"-->
    <!--class="mb-0"-->
    <!--&gt;</v-progress-linear>-->
    <!--</v-card-text>-->
    <!--</div>-->
    <div class="tasks-content py-2 px-2">
      <div class="task-item" v-for="task in items" :key="task.id">
        <div class="dg-task">
          <div class="text">
            <router-link v-if="checkPermission('tasks', 'manage')" slot="activator" :to="`/task/${task.id}`">
              <span class="task-id" hidden> {{ task.id }} </span>
              <span @click="clickTask()"><strong>{{ task.identifier }}</strong></span>
              <span @click="clickTask()"> - {{ task.id_text }}</span>
            </router-link>
            <div v-else slot="activator">
              <span class="task-id" hidden> {{ task.id }} </span>
              <span><strong>{{ task.identifier }}</strong></span>
              <span> - {{ task.id_text }}</span>
            </div>
          </div>

          <div class="task-info">
            <div class="urgency-client">
              <v-tooltip right>
                <v-avatar class="ml-1" slot="activator" v-if="task.urgency" size="25" :color="translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).color">
                  {{ translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).text.charAt(0) }}
                </v-avatar>
                <span> {{ task.urgency ? translate('value.task_urgency').find((val)=>{ return val.value === task.urgency }).text : '' }} </span>
              </v-tooltip>
            </div>
            <span :class="moment(task.end).diff(moment(), 'minutes') < 0 ? 'red--text ml-2' : 'black--text ml-2'">
              {{ type !== '0' ? 'Horário: ' + moment(task.commitment ? task.begin : task.end).format('HH:mm') : 'Data: ' + 
               moment(task.commitment ? task.begin : task.end).format('DD/MM/YYYY HH:mm') }}
            </span>
          </div>
        </div>
      </div>
      <div class="show-more mt-1" v-if="(qttTasks > items.length)" @click="$emit('moreTasks')">
        <span style="cursor: pointer;"><strong>Mostrar mais</strong></span>
      </div>
    </div>
  </div>
  <div v-else class="task-done">
    <span>Parabéns! Você finalizou suas tarefas por aqui.</span>
    <br>
    <img class="img" :src="`${basePath}images/task_done.png`" alt="avatar">
  </div>
</template>
<style scoped>
  .task-done{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    height: 50vh;
  }

  .task-done span{
    font-size: 1.5em;
    color: #333;
  }
  
  .task-done .img{
    width: auto;
	  height: 70%;
  }

  .calendar-content .toggle-button {
    position: absolute;
    right: 0;
    top: 0;
  }

  .tasks {
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid #00acc2;
    border-radius: 5px 5px 0 0;
    padding: 0 8px;
    height: 50vh;
  }

  .tasks .task-title {
    display: flex;
    flex-direction: column;
  }

  .tasks .task-title .text-filter {
    display: flex;
    flex-direction: column;
    align-items: left;
  }

  .tasks .tasks-content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding-right: 2px;
  }

  .tasks .tasks-content .task-item {
    border: 1px solid #00acc250;
    padding: 6px;
    border-radius: 5px;
    margin-top: 10px;
  }

  .tasks .tasks-content .task-item a {
    color: #02444d;
  }

  .tasks .tasks-content .task-item:nth-child(1) {
    margin-top: 0;
  }

  .tasks .tasks-content .task-item .text span {
    word-wrap: break-word;
  }

  .tasks .tasks-content .task-item .task-info {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin: 8px 0;
  }

  .tasks .tasks-content .task-item .task-info .urgency-client {
    display: flex;
  }

  .tasks .tasks-content .task-item .task-info .urgency-client .client {
    margin-right: 6px;
  }

  .dg-task {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
</style>
<script>
  /* eslint-disable */
  import access from './../../mixin/access'
  import moment from 'moment'
  export default {
    mixins: [access],
    name: 'PUserTasksList',
    props: {
      taskLoading: false,
      qttTasks: 0,
      type: 0,
      items: {
        type: Array,
        default: []
      }
    },
    data: () => ({
      basePath: process.env.API,
    }),
    methods: {
      clickTask () {
        this.$emit('closeUserTasks')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PUserTasksList.vue